import { render, staticRenderFns } from "./StatementsResult.vue?vue&type=template&id=47681a83&scoped=true"
import script from "./StatementsResult.vue?vue&type=script&lang=js"
export * from "./StatementsResult.vue?vue&type=script&lang=js"
import style0 from "./StatementsResult.vue?vue&type=style&index=0&id=47681a83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47681a83",
  null
  
)

export default component.exports